import MessageLoader from 'common/MessageLoader'
import Alert from 'react-bootstrap/Alert'
import classNames from 'classnames'

interface PageLoaderComponentOverrides {
  Empty?: JSX.Element
  Loading?: JSX.Element
  Error?: JSX.Element
}

interface PageLoaderProps {
  isLoading: boolean
  error?: string | undefined
  isEmpty?: boolean
  loadingMessage?: string
  emptyMessage?: string
  Components?: PageLoaderComponentOverrides
  loadingContainerClass?: string
  emptyContainerClass?: string
}

/*
 * This component handles these page states while making a API call, Loading, Error, Empty
 * This would mostly be used when there is a component where content of it would depends on the API data
 * And this component would handle displaying those states on the UI side till the data is loaded
 */
const PageLoader: React.FC<PageLoaderProps> = ({
  isLoading,
  isEmpty,
  error,
  loadingMessage,
  emptyMessage,
  Components,
  children,
  loadingContainerClass,
  emptyContainerClass = '',
}) => {
  const pageStateContainerClass = 'flex-fill flex-center'

  if (isLoading) {
    return (
      <div className={`${loadingContainerClass} ${pageStateContainerClass}`}>
        {Components?.Loading || <MessageLoader message={loadingMessage} />}
      </div>
    )
  }

  if (error) {
    return (
      Components?.Error || (
        <div className="flex-fill">
          <Alert variant="danger text-center">{error}</Alert>
        </div>
      )
    )
  }

  if (isEmpty) {
    return (
      <div className={classNames(emptyContainerClass, pageStateContainerClass)}>
        {Components?.Empty || (
          <span className="width-18 fs-18 font-weight-bold text-center">
            {emptyMessage}
          </span>
        )}
      </div>
    )
  }

  return <>{children}</>
}

PageLoader.defaultProps = {
  loadingMessage: 'Loading...',
  emptyMessage: 'No records found.',
}

export default PageLoader
